import React from 'react';
import DG_TreeSelect_Department from "../../../../custom/data-entry/tree-select/department/Department";
import {TreeSelect} from "antd";
import {t} from "i18next";

const SelectDepartmentReport = props => {

    return (
            <DG_TreeSelect_Department

            treeCheckable={"true"}
            showCheckedStrategy={TreeSelect.SHOW_ALL}
            allowClear={true}
            placeholder={ t("tnp.components.report.selectAll")}
            {...props}
            // onChange={(values) => {
            //     searchParams.delete(KeyFilter.department_id)
            //     if(values){
            //
            //         values.map(item => {
            //             searchParams.append(KeyFilter.department_id, item)
            //             return []
            //         })
            //
            //         navigate(`?${searchParams.toString()}`)
            //         dispatch(onReloadData(!reloadData))
            //     }
            // }}

        />
    );
};

SelectDepartmentReport.propTypes = {
    
};

export default SelectDepartmentReport;
